export default {
    page_title: "Kevi | Relatório de Clientes",
    title: "Relatório de Clientes",
    active_clients_description:
        "Total de clientes com pelo menos uma compra nos {0} dias anteriores ao início de cada mês",
    headings: {
        active_clients: "Clientes ativos",
        retention_rate: "Taxa de aproveitamento",
        clients_by_action: "Clientes por ação",
    },
    actions: {
        retained: "Retidos (< {0}d)",
        reactivated: "Reativados (entre {0}d e {1}d)",
        recovered: "Recuperados (> {0}d)",
        new_first_purchase: "Novos (1a Compra)",
    },
    filters: {
        client_segment: "Segmento",
    },
};
